import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { QueryRoutePage } from "../app/queryRoute";

export const Route = createFileRoute("/query")({
  component: QueryRoute,
});

function QueryRoute(): JSX.Element {
  const search = Route.useSearch();
  return <QueryRoutePage search={search} />;
}
